import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../helpers/language';

const SolutionsIntroSection = () => {
    const { language } = useLanguage();
    const t = translations[language].solutionsIntro;

    return (
        <section className="secction-solutions" id='intro' data-aos="fade-up">
            <div className="solutions-letf">
                <h1 className="solutions-title">
                    {t.line1}<br />
                    {t.line2}<br />
                    {t.line3} <span className="text-span">{t.highlight}</span>
                </h1>
                <p className="services-description">{t.description}</p>
                <div className="solution-buttom">
                    <a href="#about" className="btn btn-blank w-button">{t.buttons.about}</a>
                    <a href="#id-section-services" className="btn btn-black w-button">{t.buttons.services}</a>
                </div>
		<div className="solution-buttom">
			<a href="mailto:helpdesk@castletechllc.com"><img src="/images/boton_ticket.png" alt="" /></a>
                </div>
            </div>
            <div className="solutions-right"></div>
        </section>
    );
};

export default SolutionsIntroSection;
